<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0'" *ngIf="ShowPanel">

    <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">Tareas</div>
        <button *ngIf="showAddTaskbtn" mat-icon-button (click)="openAddtaskPopup()">
            <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
        </button>
    </div>
    <div class="p-10 pt-0 pr-0 tareas-scroll">
        <table>
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr *ngFor="let task of taskService.tasks">

                <!-- Options -->
                <td class="w-30px">
                    <mat-menu #appMenu="matMenu">
                        <button *ngIf="taskService.isPermitPrint" mat-menu-item (click)="PrintDocument(task)">
                            <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                                print
                            </mat-icon> Imprimir
                        </button>
                        <button *ngIf="taskService.isPermitChangeTime" mat-menu-item (click)="addTimePopup(task)">
                            <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                                timer
                            </mat-icon>Cambiar Hora
                        </button>
                        <button *ngIf="taskService.isPermitDeleteTask" mat-menu-item (click)="deleteTask(task)">
                            <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                                delete_outline
                            </mat-icon> Eliminar
                        </button>
                    </mat-menu>

                    <button mat-icon-button [matMenuTriggerFor]="appMenu">
                        <mat-icon class="f-s-15">more_vert</mat-icon>
                    </button>
                </td>

                <td class="w-25px text-center">
                    <span [ngClass]="task.Icon" aria-hidden="true"></span>
                </td>
                <td class="w-80px">{{task.Fecha | date: 'dd/MM/yyyy'}}</td>
                <td class="w-40px">{{task.Hora | date: 'HH:mm'}}</td>
                <td class="w-30px text-center">
                    <div *ngIf="task.FReclamacion!=Null" class="round-r-mark" matTooltipClass="formatted" [matTooltip]="task.ToolTipText">
                        <span>R</span>
                    </div>
                </td>
                <td class="t2-tps" matTooltipClass="formatted" matTooltip="{{task.Author}}">{{task.Author | titlecase}}</td>
                <!--<td *ngIf="task.Tarea.length>25" class="t2-tps" matTooltipClass="formatted" matTooltip="{{task.Tarea}}">{{task.Tarea}}</td>-->
                <!--<td *ngIf="task.Tarea.length<25" class="t2-tps">{{task.Tarea}}</td>-->
                <td class="t2-tps" matTooltipClass="formatted" matTooltip="{{task.Tarea}}">{{task.Tarea}}</td>


                <!-- This is a quick implementation. The tool is displayed every time even the
    comment is short. If there is a way to hide the tooltip when text is short apply it -->
                <td class="tl-tps" #taskCommentRef matTooltipClass="formatted" matTooltip="{{task.Comentario}}">
                    <span class="task-comment-text"> {{task.Comentario}} </span>
                    <mat-icon *ngIf="task.Comentario!=null" (click)="copyObservacion(task.Comentario)" class="copy-icon">file_copy</mat-icon>
                </td>

                <!-- Registro and User -->
                <td class="text-right w-20px">
                    <mat-icon class="info-icon" *ngIf="task.registroHint" matTooltipClass="formatted"
                              [matTooltip]="task.registroHint">
                        info
                    </mat-icon>
                </td>

            </tr>
        </table>
        <div class="m-auto" *ngIf="taskService.IsLoading">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
    </div>
</div>